// ============================================================
// src/config/planos.js
// Produtos do IntegrAI → módulos (abas) de cada empresa
//
// tenant.plano   → 'crm' | 'entregas' nas empresas criadas depois
//                  da divisão em produtos (27/09/2026)
// tenant.modulos → lista própria das empresas anteriores; nelas o
//                  plano ('profissional', 'basico') não quer dizer nada
//
// O Financeira (IntegrAI Finance) é outro sistema e não entra aqui.
// ============================================================

// IDs dos módulos devem coincidir com ABAS em App.js

// Camada comum aos três produtos
const MODULOS_COMUNS = [
  'dashboard',
  'atendimento',
  'disparo',
  'templates-meta',
  'metricas-meta',
  'whatsapp',
  'instancias',
  'config-ia',
  'relatorios',
  'usuarios',
  'logs',
  'configuracoes',
];

export const PRODUTOS = {
  crm: {
    label: 'IntegrAI CRM',
    modulos: [
      ...MODULOS_COMUNS,
      'crm-recompra',   // calcula o ciclo pela tabela vendas
      'vendas',
      'financeiro',
      'analises',
    ],
  },
  entregas: {
    label: 'IntegrAI Entregas',
    modulos: [
      ...MODULOS_COMUNS,
      'entregas',
      'vendas',
      'estoque',
      'cadastros',
      'financeiro',
      'analises',
    ],
  },
};

/**
 * Produto da empresa, ou null para as empresas anteriores aos produtos.
 * @param {object} tenant
 * @returns {object|null}
 */
export function resolverProduto(tenant) {
  return PRODUTOS[tenant?.plano] || null;
}

/**
 * Retorna os IDs de módulos que devem ser visíveis para o tenant.
 *
 *  1. produto (tenant.plano) → a lista vem daqui, e mudar o produto
 *     no código muda todas as empresas dele
 *  2. tenant.modulos         → lista própria das empresas anteriores
 *  3. null                   → App.js mostra todas as abas
 *
 * @param {object} tenant
 * @returns {string[]|null}
 */
export function resolverModulos(tenant) {
  if (!tenant) return null;

  const produto = resolverProduto(tenant);
  if (produto) return produto.modulos;

  if (tenant.modulos?.length) return tenant.modulos;

  return null;
}
